var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'text-warning': _vm.entry['daylog']['status'] === 1
    }},[_c('i',{staticClass:"far fa-clock fa-fw"}),(
            _vm.entry['daylog']['time_stop'] === null &&
                _vm.entry['daylog']['time_start'] === null
        )?[_vm._v(" ---")]:(
            _vm.entry['daylog']['time_stop'] === null ||
                _vm.entry['daylog']['time_start'] === null
        )?[_c('v-time',{attrs:{"time":_vm.entry['daylog']['time_start']}}),_vm._v(" - "),_c('i',{staticClass:"far fa-question-square"})]:[_c('v-time',{attrs:{"time":_vm.entry['daylog']['time_start']}}),_vm._v(" - "),(_vm.entry['daylog']['time_stop'])?_c('v-time',{attrs:{"time":_vm.entry['daylog']['time_stop']}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }